import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Job } from './models/job';
import { Subject } from 'rxjs';

@Component({
  selector: 'modal-content',
  templateUrl: './job-modal.component.html'
})
export class JobModalComponent {

  public onSave: Subject<Job>;
  mode: string = 'new';
  job: Job;


  constructor(public bsModalRef: BsModalRef) { }


  ngOnInit(): void {

    this.onSave = new Subject();

  }

  save(job: Job) {
    console.log('Save Triggered');
    this.onSave.next(job);

    this.bsModalRef.hide();
  }

  cancel() {
    this.bsModalRef.hide();
  }

}
